export default {
  group: {
    searchPlaceholder: '分类编码/分类名称',
    classifyNo: '分类编码',
    classifyName: '分类名称',
    remarks: '备注',
    classificationGroup: '分组分类',
    addByName: '创建人员',
    adddate: '创建时间',
    updateByName: '更改人员',
    upddate: '更改时间',
    registeredClassify: '注册分类',
    transferTitle: ['全部', '已选']
  },
  info: {
    searchPlaceholder: '供应商编号/供应商名称',
    titles: ['基础资料', '工商信息', '银行信息', '联系人', '资质信息'],
    platformAccount: '企业账号',
    supplierNo: '供应商编号',
    supplierName: '供应商名称',
    creditCode: '统一社会信用代码',
    status: '供应商状态',
    statusOptions: ['潜在', '合作', '淘汰', '合格'],
    name: '企业名称',
    officeNo: '机构编码',
    officeAbbreviation: '企业简称',
    officeType: '机构别',
    dutyParagraph: '纳税人识别号',
    registrationNo: '注册号',
    organizationalCode: '组织机构代码',
    managementModel: '经营模式',
    businessStatus: '经营状态',
    legalRepresentative: '法定代表人',
    industry: '行业类型',
    establishDate: '成立日期',
    approvalDate: '核准日期',
    officeScale: '企业规模/人',
    annualTurnover: '年营业额/万元',
    registeredCapital: '注册资本/万元',
    areaBelong: '所属地区',
    registerOffice: '登记机关',
    regionId: '企业地址',
    detailAddress: '详细地址',
    mainProducts: '主营产品',
    businessScope: '经营范围',
    openingBank: '开户行',
    openingBankName: '开户名称',
    bankAccount: '银行账号',
    openingBankOutlets: '开户行网点',
    master: '联系人',
    phone: '手机号码',
    qualificationsNo: '资质编号',
    qualificationsName: '资质名称',
    dueDays: '到期提醒天数',
    certificateDurationType: '证书期限类型',
    qualificationsEffectiveDate: '资质生效日',
    qualificationsDueDate: '资质到期日',
    changeStatus: '变更供应商状态'
  }
}
